/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetIntegrationIdByNameQueryVariables = Types.Exact<{
  providerName: Types.Integration_Names_Enum;
}>;

export type GetIntegrationIdByNameQuery = {
  __typename?: 'query_root';
  integrations: Array<{ __typename?: 'integrations'; id: string }>;
};

export type GetAllOrgIntegrationDetailsQueryVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
}>;

export type GetAllOrgIntegrationDetailsQuery = {
  __typename?: 'query_root';
  organization_integrations: Array<{
    __typename?: 'organization_integrations';
    id: string;
    name: string;
    auth_name: Types.Integration_Auth_Names_Enum;
    disabled: boolean;
    is_configurable_by_user: boolean;
    usage_stats?: {
      __typename?: 'integration_usage_stats_view';
      controls_count?: number | null;
      evidence_count?: number | null;
    } | null;
    integration: { __typename?: 'integrations'; name: Types.Integration_Names_Enum };
  }>;
};

export type GetOrgIntegrationConfigStateBackofficeQueryVariables = Types.Exact<{
  orgIntegrationId: Types.Scalars['uuid']['input'];
}>;

export type GetOrgIntegrationConfigStateBackofficeQuery = {
  __typename?: 'query_root';
  org_integration_config_state?: {
    __typename?: 'OrgIntegrationConfigState';
    orgIntegrationId: string;
    config: any;
    encryptedFields: Array<{
      __typename?: 'EncryptedConfigFieldState';
      path: Array<string>;
      configured: boolean;
    }>;
  } | null;
};

export type InsertOrgIntegrationBackofficeMutationVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
  integrationId: Types.Scalars['uuid']['input'];
  connectorName: Types.Scalars['citext']['input'];
  authName: Types.Integration_Auth_Names_Enum;
}>;

export type InsertOrgIntegrationBackofficeMutation = {
  __typename?: 'mutation_root';
  insert_organization_integrations_one?: {
    __typename?: 'organization_integrations';
    id: string;
  } | null;
};

export type UpdateOrgIntegrationBackofficeMutationVariables = Types.Exact<{
  orgIntegrationId: Types.Scalars['uuid']['input'];
  orgIntegration: Types.Organization_Integrations_Set_Input;
}>;

export type UpdateOrgIntegrationBackofficeMutation = {
  __typename?: 'mutation_root';
  update_organization_integrations_by_pk?: {
    __typename?: 'organization_integrations';
    id: string;
  } | null;
};

export type SetOrgIntegrationConfigMutationVariables = Types.Exact<{
  input: Types.SetOrgIntegrationConfigInput;
}>;

export type SetOrgIntegrationConfigMutation = {
  __typename?: 'mutation_root';
  set_org_integration_config?: {
    __typename?: 'OrgIntegrationConfigState';
    orgIntegrationId: string;
    config: any;
    encryptedFields: Array<{
      __typename?: 'EncryptedConfigFieldState';
      path: Array<string>;
      configured: boolean;
    }>;
  } | null;
};

export type DeleteOrgIntegrationMutationVariables = Types.Exact<{
  orgIntegrationId: Types.Scalars['uuid']['input'];
}>;

export type DeleteOrgIntegrationMutation = {
  __typename?: 'mutation_root';
  delete_organization_integrations_by_pk?: {
    __typename?: 'organization_integrations';
    id: string;
  } | null;
};

export const GetIntegrationIdByNameDocument = `
    query GetIntegrationIdByName($providerName: integration_names_enum!) {
  integrations(where: {name: {_eq: $providerName}}) {
    id
  }
}
    ` as string &
  TypedDocumentNode<GetIntegrationIdByNameQuery, GetIntegrationIdByNameQueryVariables>;
export const GetAllOrgIntegrationDetailsDocument = `
    query GetAllOrgIntegrationDetails($orgId: uuid!) {
  organization_integrations(
    where: {organization_id: {_eq: $orgId}, integration: {disabled: {_eq: false}}}
    order_by: [{integration: {name: asc}}, {created_at: asc}]
  ) {
    id
    name
    auth_name
    disabled
    is_configurable_by_user
    usage_stats {
      controls_count
      evidence_count
    }
    integration {
      name
    }
  }
}
    ` as string &
  TypedDocumentNode<GetAllOrgIntegrationDetailsQuery, GetAllOrgIntegrationDetailsQueryVariables>;
export const GetOrgIntegrationConfigStateBackofficeDocument = `
    query GetOrgIntegrationConfigStateBackoffice($orgIntegrationId: uuid!) {
  org_integration_config_state(orgIntegrationId: $orgIntegrationId) {
    orgIntegrationId
    config
    encryptedFields {
      path
      configured
    }
  }
}
    ` as string &
  TypedDocumentNode<
    GetOrgIntegrationConfigStateBackofficeQuery,
    GetOrgIntegrationConfigStateBackofficeQueryVariables
  >;
export const InsertOrgIntegrationBackofficeDocument = `
    mutation InsertOrgIntegrationBackoffice($orgId: uuid!, $integrationId: uuid!, $connectorName: citext!, $authName: integration_auth_names_enum!) {
  insert_organization_integrations_one(
    object: {organization_id: $orgId, integration_id: $integrationId, name: $connectorName, auth_name: $authName, config: {}, encrypted_config: "", disabled: false}
  ) {
    id
  }
}
    ` as string &
  TypedDocumentNode<
    InsertOrgIntegrationBackofficeMutation,
    InsertOrgIntegrationBackofficeMutationVariables
  >;
export const UpdateOrgIntegrationBackofficeDocument = `
    mutation UpdateOrgIntegrationBackoffice($orgIntegrationId: uuid!, $orgIntegration: organization_integrations_set_input!) {
  update_organization_integrations_by_pk(
    pk_columns: {id: $orgIntegrationId}
    _set: $orgIntegration
  ) {
    id
  }
}
    ` as string &
  TypedDocumentNode<
    UpdateOrgIntegrationBackofficeMutation,
    UpdateOrgIntegrationBackofficeMutationVariables
  >;
export const SetOrgIntegrationConfigDocument = `
    mutation SetOrgIntegrationConfig($input: SetOrgIntegrationConfigInput!) {
  set_org_integration_config(input: $input) {
    orgIntegrationId
    config
    encryptedFields {
      path
      configured
    }
  }
}
    ` as string &
  TypedDocumentNode<SetOrgIntegrationConfigMutation, SetOrgIntegrationConfigMutationVariables>;
export const DeleteOrgIntegrationDocument = `
    mutation DeleteOrgIntegration($orgIntegrationId: uuid!) {
  delete_organization_integrations_by_pk(id: $orgIntegrationId) {
    id
  }
}
    ` as string &
  TypedDocumentNode<DeleteOrgIntegrationMutation, DeleteOrgIntegrationMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetIntegrationIdByName: build.query<
      GetIntegrationIdByNameQuery,
      GetIntegrationIdByNameQueryVariables
    >({
      query: (variables) => ({ document: GetIntegrationIdByNameDocument, variables }),
    }),
    GetAllOrgIntegrationDetails: build.query<
      GetAllOrgIntegrationDetailsQuery,
      GetAllOrgIntegrationDetailsQueryVariables
    >({
      query: (variables) => ({ document: GetAllOrgIntegrationDetailsDocument, variables }),
    }),
    GetOrgIntegrationConfigStateBackoffice: build.query<
      GetOrgIntegrationConfigStateBackofficeQuery,
      GetOrgIntegrationConfigStateBackofficeQueryVariables
    >({
      query: (variables) => ({
        document: GetOrgIntegrationConfigStateBackofficeDocument,
        variables,
      }),
    }),
    InsertOrgIntegrationBackoffice: build.mutation<
      InsertOrgIntegrationBackofficeMutation,
      InsertOrgIntegrationBackofficeMutationVariables
    >({
      query: (variables) => ({ document: InsertOrgIntegrationBackofficeDocument, variables }),
    }),
    UpdateOrgIntegrationBackoffice: build.mutation<
      UpdateOrgIntegrationBackofficeMutation,
      UpdateOrgIntegrationBackofficeMutationVariables
    >({
      query: (variables) => ({ document: UpdateOrgIntegrationBackofficeDocument, variables }),
    }),
    SetOrgIntegrationConfig: build.mutation<
      SetOrgIntegrationConfigMutation,
      SetOrgIntegrationConfigMutationVariables
    >({
      query: (variables) => ({ document: SetOrgIntegrationConfigDocument, variables }),
    }),
    DeleteOrgIntegration: build.mutation<
      DeleteOrgIntegrationMutation,
      DeleteOrgIntegrationMutationVariables
    >({
      query: (variables) => ({ document: DeleteOrgIntegrationDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useGetIntegrationIdByNameQuery,
  useLazyGetIntegrationIdByNameQuery,
  useGetAllOrgIntegrationDetailsQuery,
  useLazyGetAllOrgIntegrationDetailsQuery,
  useGetOrgIntegrationConfigStateBackofficeQuery,
  useLazyGetOrgIntegrationConfigStateBackofficeQuery,
  useInsertOrgIntegrationBackofficeMutation,
  useUpdateOrgIntegrationBackofficeMutation,
  useSetOrgIntegrationConfigMutation,
  useDeleteOrgIntegrationMutation,
} = injectedRtkApi;
